// @flow strict
import * as React from 'react';
import {useEnvironmentContext} from 'src/hooks/useEnvironmentContext';
import {AuthFlow} from 'src/components/authentication/auth-flow.js';

import {
  TitleMedium,
  SubTitleMedium,
  BodyMedium,
  BodyLargeBold,
  BodyMediumBold,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {
  RadioGroup,
  RadioButton,
} from '@spaced-out/ui-design-system/lib/components/RadioButton';
import classify from 'src/utils/classify';
import css from './authenticator-and-sms-register.css';


type Props = {goToPage: (page: string, newMfaFlow: ?string) => void};

const AuthenticatorAndSmsRegister = ({goToPage}: Props): React.Node => {
  const {isExtension} = useEnvironmentContext();
  const [authType, setAuthType] = React.useState('SMS');

  const handleContinueClick = async () => {
    if (authType === 'SMS') {
      goToPage(
        AuthFlow.SMS_REGISTRATION.PHONE_REGISTRATION,
        'SMS_REGISTRATION',
      );
    } else {
      goToPage(AuthFlow.TOTP.TOTP_REGISTRATION, 'TOTP');
    }
  };
  return (
    <div className={classify(css.container, {[css.containerExt]: isExtension})}>
      {isExtension ? (
        <SubTitleMedium className={css.title}>
          Select authentication method
        </SubTitleMedium>
      ) : (
        <TitleMedium className={css.title}>
          Select authentication method
        </TitleMedium>
      )}
      <RadioGroup
        align="vertical"
        name="auth-type"
        value={authType}
        onChange={setAuthType}
        classNames={{wrapper: css.radioGroup}}
      >
        <RadioButton
          value="SMS"
          classNames={{
            wrapper: classify(css.radioButton, {
              [css.radioButtonExt]: isExtension,
              [css.radioButtonSelected]: authType === 'SMS',
            }),
            label: css.radioLabel,
          }}
        >
          {isExtension ? (
            <BodyMediumBold>Text Message</BodyMediumBold>
          ) : (
            <>
              <BodyLargeBold className={css.stepText}>
                Text Message
              </BodyLargeBold>
              <BodyMedium color="secondary">
                Get the verification code sent to your phone
              </BodyMedium>
            </>
          )}
        </RadioButton>
        <RadioButton
          value="TOTP"
          classNames={{
            wrapper: classify(css.radioButton, {
              [css.radioButtonExt]: isExtension,
              [css.radioButtonSelected]: authType === 'TOTP',
            }),
            label: css.radioLabel,
            radio: classify({[css.radio]: !isExtension}),
          }}
        >
          {isExtension ? (
            <BodyMediumBold>Authenticator App</BodyMediumBold>
          ) : (
            <>
              <BodyLargeBold className={css.stepText}>
                Authenticator App
              </BodyLargeBold>

              <BodyMedium color="secondary">
                Enter the 6-digit code from your authenticator app
              </BodyMedium>
            </>
          )}
        </RadioButton>
      </RadioGroup>
      <Button
        onClick={handleContinueClick}
        size={isExtension ? 'small' : 'medium'}
        type="primary"
      >
        Continue
      </Button>
    </div>
  );
};

export default AuthenticatorAndSmsRegister;
